export default "__VITE_PUBLIC_ASSET__78bb910c__"